import React, { useContext } from "react";
import { useParams, useLocation } from 'react-router-dom';
import { Box, Typography, Stack } from '@mui/material';
import PartCard from "../components/PartCard";
import { AppContext } from "../App";
import { useUser } from "../UserContext";

export default function PartDetailsScreen() {
  const location = useLocation();
  const { part } = location.state || {};
  const params = useParams();
  const { userRecord } = useContext(AppContext);
  const { activeProvider } = useUser();

  const getRelativeLink = (path, activeProvider) => {
    if (activeProvider) {
      return `/${activeProvider.companyPath}${path}`;
    }
    if (userRecord?.companyPath) {
      return `/${userRecord?.companyPath}${path}`;
    }
    return path;
  };

  console.log('Location:', location);
  console.log('Location State:', location.state);
  console.log('Part:', part);
  console.log('URL Params:', params);

  if (!part) {
    return (
      <Box sx={{ 
        backgroundColor: '#000',
        minHeight: '100vh',
        padding: '20px'
      }}>
        <Typography sx={{ color: '#24e4ff' }}>
          No part data found. Debug info:
        </Typography>
        <pre style={{ color: '#24e4ff' }}>
          {JSON.stringify({
            locationState: location.state,
            params: params,
            pathname: location.pathname
          }, null, 2)}
        </pre>
      </Box>
    );
  }

  return (
    <Box sx={{ 
      backgroundColor: '#000',
      minHeight: '100vh',
      padding: '20px'
    }}>
      <Stack spacing={2}>
        <Typography variant="h4" sx={{ color: '#24e4ff' }}>
          Part Details
        </Typography>
        <PartCard 
          part={part}
          showPrice={true}
          getRelativeLink={(path) => getRelativeLink(path, activeProvider)}
        />
        <pre style={{ color: '#24e4ff' }}>
          {JSON.stringify(part, null, 2)}
        </pre>
      </Stack>
    </Box>
  );
}
